/**
 * Mandira ↔ KwikPass (Shopify PLUGIN only)
 *
 * Visual: Mandira profile icon via CSS on the real KP button (no JS icon swap)
 * Guest click: native KP login button (we do not block it)
 * Logged-in click: /pages/kp-account
 * Fallback Mandira link: open KP popup or /pages/login
 */
(function () {
  var ACCOUNT_URL = '/pages/kp-account';
  var LOGIN_URL = '/pages/login';
  var accountNavBound = false;
  var openingLogin = false;
  var userRequestedLogin = false;
  var autoSuppressUntil = Date.now() + 6000;

  function isLoginPage() {
    return Boolean(document.querySelector('[data-kwikpass-login]'));
  }

  function getSdk() {
    return window.__KP_LOGIN_SDK_INSTANCE__;
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    // KP toggles logged-in vs login via inline display on wrappers
    var parent = el.closest('#loggedin-icons, #loggedin-icons-mobile');
    if (parent) {
      var ps = window.getComputedStyle(parent);
      if (ps.display === 'none' || ps.visibility === 'hidden') return false;
    }
    return true;
  }

  function isLoggedIn() {
    if (window.MandiraCustomer && window.MandiraCustomer.loggedIn === true) return true;
    // #icon-kwikpass is always in the DOM after KP injects — only count when shown
    if (isVisible(document.getElementById('icon-kwikpass'))) return true;
    if (isVisible(document.getElementById('icon-kwikpass-mobile'))) return true;
    var loggedInWrap = document.getElementById('loggedin-icons');
    if (isVisible(loggedInWrap)) return true;
    return false;
  }

  function markLoggedOut() {
    if (window.MandiraCustomer) window.MandiraCustomer.loggedIn = false;
    userRequestedLogin = false;
    document.documentElement.classList.remove('mandira-kp-user-login');
    document.body.classList.remove('mandira-kp-user-login');
  }

  function markUserLogin() {
    userRequestedLogin = true;
    document.documentElement.classList.add('mandira-kp-user-login');
    document.body.classList.add('mandira-kp-user-login');
  }

  function getKpLoginButton() {
    return (
      document.getElementById('kp-login-button-header-logo') ||
      document.getElementById('kp-login-button-header-logo-mobile') ||
      document.querySelector('.header-account-slot .header--icon:not(.header--icon--mobile)') ||
      null
    );
  }

  function openKpPopup() {
    markUserLogin();
    try {
      if (typeof window.handleKpAndShopifyLogin === 'function') {
        window.handleKpAndShopifyLogin();
        return true;
      }
      var sdk = getSdk();
      if (sdk && typeof sdk.kwikForm === 'function') {
        sdk.kwikForm();
        return true;
      }
      // Avoid btn.click() — our capture listener would re-intercept it
      var btn = getKpLoginButton();
      if (btn && typeof btn.onclick === 'function') {
        btn.onclick();
        return true;
      }
      if (btn) {
        var attr = btn.getAttribute('onclick') || '';
        if (attr.indexOf('handleKpAndShopifyLogin') !== -1 && typeof window.handleKpAndShopifyLogin === 'function') {
          window.handleKpAndShopifyLogin();
          return true;
        }
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function openLoginFlow() {
    if (openingLogin) return;
    openingLogin = true;
    markUserLogin();

    if (openKpPopup()) {
      window.setTimeout(function () {
        openingLogin = false;
      }, 1000);
      return;
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (openKpPopup()) {
        window.clearInterval(timer);
        openingLogin = false;
        return;
      }
      if (tries > 20) {
        window.clearInterval(timer);
        openingLogin = false;
        window.location.assign(LOGIN_URL);
      }
    }, 150);
  }

  function goAccount() {
    window.location.assign(ACCOUNT_URL);
  }

  function syncHeaderIcons() {
    var slot = document.querySelector('.header-account-slot');
    if (slot) {
      var kpReady = Boolean(
        slot.querySelector(
          '#kp-login-button-header-logo, #icon-kwikpass, .header--icon:not(.header--icon--mobile)',
        ),
      );
      slot.classList.toggle('mandira-kp-ready', kpReady);
    }

    // Mandira icon stays visible forever — never hide/replace it
    document.querySelectorAll('[data-mandira-account-link], .mandira-account-link').forEach(function (link) {
      link.style.setProperty('opacity', '1', 'important');
      link.style.setProperty('visibility', 'visible', 'important');
      link.style.removeProperty('display');
      link.removeAttribute('hidden');
      if (isLoggedIn()) {
        link.setAttribute('href', ACCOUNT_URL);
        link.removeAttribute('data-mandira-login');
        link.setAttribute('aria-label', 'Account');
      } else {
        link.setAttribute('href', '#');
        link.setAttribute('data-mandira-login', '');
        link.setAttribute('aria-label', 'Sign in');
      }
    });
  }

  function paintKpOrange() {
    var orange = '#B54B11';
    document.documentElement.style.setProperty('--kp-color-primary', orange);
    document.documentElement.style.setProperty('--kp-color-avatar', orange);
    document.documentElement.style.setProperty('--kp-color-processing', orange);
    var host = document.getElementById('kp-account-wrapper');
    if (host && host.shadowRoot && !host.shadowRoot.getElementById('mandira-kp-orange-theme')) {
      var style = document.createElement('style');
      style.id = 'mandira-kp-orange-theme';
      style.textContent =
        ':host,*{--kp-color-primary:' +
        orange +
        '!important;--kp-color-avatar:' +
        orange +
        '!important;}h3.kp-title,.kp-title{display:none!important;}';
      host.shadowRoot.appendChild(style);
    }
  }

  function closeAutoKpPopup() {
    if (userRequestedLogin || isLoginPage()) return;
    if (Date.now() > autoSuppressUntil) return;

    document.querySelectorAll('.kp-loader-popup, #kp-modal').forEach(function (node) {
      var btn = node.querySelector(
        'button[aria-label*="lose" i], .close, [data-dismiss], [class*="close"]',
      );
      if (btn) {
        try {
          btn.click();
        } catch (e) {
          /* ignore */
        }
      } else {
        node.style.setProperty('display', 'none', 'important');
        node.setAttribute('hidden', '');
      }
    });
  }

  function bindClicks() {
    if (accountNavBound) return;
    accountNavBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (
          target.closest(
            '#kp-logout-btn, [data-kp-logout], a[href*="logout"], button[id*="logout" i]',
          )
        ) {
          markLoggedOut();
          return;
        }

        // Account slot hit — KP glyphs are hidden; we open login/account ourselves
        var accountHit = target.closest(
          [
            '.header-account-slot .header--icon',
            '.header-account-slot .header--icon--mobile',
            '#kp-login-button-header-logo',
            '#kp-login-button-header-logo-mobile',
            '#icon-kwikpass',
            '#icon-kwikpass-mobile',
            '#loggedin-icons',
            '#loggedin-icons-mobile',
            '[data-mandira-account-link]',
            '.mandira-account-link',
          ].join(', '),
        );
        if (!accountHit) return;
        // Ignore clicks on KP drawer / logout UI inside the slot
        if (
          target.closest(
            '#kwikpass-drawer-desktop, #kwikpass-drawer-mobile, #kp-logout-btn, [data-kp-logout], a[href*="logout"]',
          )
        ) {
          return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        if (isLoggedIn()) goAccount();
        else openLoginFlow();
      },
      true,
    );

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest && event.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/account/login') === 0 || href.indexOf('/account/register') === 0) {
          event.preventDefault();
          openLoginFlow();
          return;
        }
        if (href === '/account' || href.indexOf('/account/') === 0) {
          event.preventDefault();
          if (isLoggedIn()) goAccount();
          else openLoginFlow();
        }
      },
      true,
    );
  }

  function enhance() {
    syncHeaderIcons();
    paintKpOrange();
    bindClicks();
    closeAutoKpPopup();
  }

  enhance();
  window.setTimeout(enhance, 400);
  window.setTimeout(enhance, 1200);
  window.setTimeout(enhance, 2500);

  var suppressTimer = window.setInterval(function () {
    closeAutoKpPopup();
    if (Date.now() > autoSuppressUntil) window.clearInterval(suppressTimer);
  }, 400);

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      window.clearTimeout(obs._t);
      obs._t = window.setTimeout(syncHeaderIcons, 150);
    });
    var slot = document.querySelector('.header-account-slot') || document.body;
    obs.observe(slot, { childList: true, subtree: true });
  }

  window.addEventListener('user-loggedin', function () {
    if (window.MandiraCustomer) window.MandiraCustomer.loggedIn = true;
    markUserLogin();
    enhance();
  });
  window.addEventListener('user_loggedin_merchant', function () {
    if (window.MandiraCustomer) window.MandiraCustomer.loggedIn = true;
    markUserLogin();
    enhance();
  });
  window.addEventListener('kwikpass-sso', function () {
    if (window.MandiraCustomer) window.MandiraCustomer.loggedIn = true;
    markUserLogin();
    enhance();
  });
  window.addEventListener('user-loggedout', markLoggedOut);
  window.addEventListener('user_loggedout', markLoggedOut);
  window.addEventListener('kwikpass-logout', markLoggedOut);

  window.MandiraKwikPassHelpers = {
    getSdk: getSdk,
    openLoginFlow: openLoginFlow,
    openKpPopup: openKpPopup,
    enhance: enhance,
    isLoggedIn: isLoggedIn,
    markUserLogin: markUserLogin,
    markLoggedOut: markLoggedOut,
  };
})();
